import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>404!!!!!!!!!!!!!!!!</h1>
            <h2>Something went wrong.</h2>
        </div>
    );
};

export default NoMatch;